import { Lock } from "lucide-react";
import { BUSINESS } from "@/data/content";

export default function TeamAccess() {
  return (
    <section data-testid="team-access-section" className="relative py-20 px-6 lg:px-24 border-t border-white/8">
      <div className="max-w-[1600px] mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div className="flex items-start gap-4">
          <Lock size={16} className="text-zinc3 mt-1" strokeWidth={1.5} />
          <div>
            <h2 className="font-mono text-[11px] tracking-[0.3em] uppercase text-zinc2" data-testid="team-access-heading">
              AMAA Team Access
            </h2>
            <p className="mt-2 text-xs text-zinc3">Authorized sales and estimating personnel only.</p>
          </div>
        </div>
        <a
          href={BUSINESS.salesToolsUrl}
          target="_blank"
          rel="nofollow noopener noreferrer"
          data-testid="team-access-btn"
          className="font-mono text-[10px] tracking-[0.22em] uppercase text-zinc3 border border-white/10 px-5 py-3 hover:text-goldw hover:border-goldw/40 transition-colors duration-300"
        >
          Open Sales Tools
        </a>
      </div>
    </section>
  );
}
